import { useEffect } from 'react';
import { useAppSelector } from '@src/redux/hooks';
import type { RootState } from '@src/redux';

const EDITABLE_SELECTOR = 'textarea, select, [contenteditable="true"], input:not([type="range"])';

function isOverlayModalOpen(state: RootState): boolean {
    return (
        state.modal.cut.isShow ||
        state.modal.loading.isShow ||
        state.modal.googleDrive.isShow ||
        state.modal.bindSocial.isShow ||
        state.modal.publishHistory.isShow ||
        state.modals.warningModalData.display ||
        state.modals.progressModalData.display ||
        state.modals.renameModalData.display ||
        state.modals.dislikeModalData.display
    );
}

/**
 * 多选栏展示时按 Esc 退出多选（与底部 X 一致：先 clearSelected 再清空 selectList）。
 * 有其它弹窗打开或焦点在可编辑控件上时不处理。
 */
export function useEscapeExitMultiSelect(active: boolean, onExit: () => void) {
    const overlayModalOpen = useAppSelector(isOverlayModalOpen);

    useEffect(() => {
        if (!active) {
            return;
        }

        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key !== 'Escape') {
                return;
            }
            if (overlayModalOpen) {
                return;
            }
            const target = e.target as HTMLElement | null;
            if (target?.closest(EDITABLE_SELECTOR)) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            onExit();
        };

        document.addEventListener('keydown', onKeyDown, true);
        return () => document.removeEventListener('keydown', onKeyDown, true);
    }, [active, overlayModalOpen, onExit]);
}
